// extracted by mini-css-extract-plugin
export default {"addDateBtn":"Activity_addDateBtn__fo7hw","subtitle":"Activity_subtitle__DM8u0","formLabel":"Activity_formLabel__Unl27"};